type CsvRow = Record<string, unknown>;

function escapeCell(value: unknown): string {
  if (value == null) return '';
  const s = typeof value === 'object' ? JSON.stringify(value) : String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** Convert an array of objects to a CSV string. Columns default to the union of keys. */
export function arrayToCsv(rows: CsvRow[], headers?: string[]): string {
  const cols =
    headers ??
    Array.from(
      rows.reduce((set, row) => {
        Object.keys(row).forEach((k) => set.add(k));
        return set;
      }, new Set<string>())
    );
  const head = cols.map(escapeCell).join(',');
  const body = rows.map((row) => cols.map((c) => escapeCell(row[c])).join(',')).join('\n');
  return body ? `${head}\n${body}` : head;
}

/** Build a CSV from rows and trigger a browser download. Prepends a BOM for Excel/UTF-8. */
export function downloadCsv(filename: string, rows: CsvRow[], headers?: string[]): void {
  const csv = arrayToCsv(rows, headers);
  const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
